<div class="map-container" #mapRef></div>
@if (isMapReady()) {
  @if (mapContents()) {
    <ng-template [ngTemplateOutlet]="mapContents()!"></ng-template>
  }
  @if (displayMyLocationButton()) {
    <div class="stadia-maps__button-wrapper my-position">
      <pxw-icon class="stadia-maps__button" icon="geolocation" (click)="onGeolocateUser()" />
    </div>
  }
}
@if (!isMapReady() || loadingGeolocation()) {
  <div class="ui-loader ui-loader--with-overlay ui-loader--local">
    <pxw-icon icon="loading" [spin]="true"></pxw-icon>
  </div>
}
